import { monthsDelivery } from '~/common/const';
import numWord from '@/common/num-word.js';

export function padDay(date: string): string {
  let day = new Date(date).getDate().toString();
  if (day.length < 2) day = '0' + day;

  return day;
}

function getDayAndMonth(date: Date) {
  return { day: date.getDate(), month: monthsDelivery[date.getMonth()] };
}

export function getDeliveryDateRange(start: string, end?: string): string {
  const startDate = new Date(start);
  const startDayMonth = getDayAndMonth(startDate);

  let endDayMonth;
  if (end) {
    const endDate = new Date(end);
    endDayMonth = getDayAndMonth(endDate);
  }

  if (!endDayMonth) {
    return `${startDayMonth.day} ${startDayMonth.month}`;
  } else if (startDayMonth.month === endDayMonth.month) {
    return `${startDayMonth.day} - ${endDayMonth.day} ${startDayMonth.month}`;
  } else {
    return `${startDayMonth.day} ${startDayMonth.month} - ${endDayMonth.day} ${endDayMonth.month}`;
  }
}

export function formatDateForNews(date: string) {
  const dateObj = new Date(date.replace(/-/g, '/'));
  const day = dateObj.getDate();
  const month = monthsDelivery[dateObj.getMonth()];
  const year = dateObj.getFullYear();
  return `${day} ${month} ${year}`;
}

// доставка в
export function getWeekDay(date: Date) {
  const days = [
    'воскресенье',
    'понедельник',
    'вторник',
    'среду',
    'четверг',
    'пятницу',
    'субботу',
  ];
  return days[date.getDay()];
}

export function getWeekDayName(date: Date) {
  const days = [
    'воскресенье',
    'понедельник',
    'вторник',
    'среда',
    'четверг',
    'пятница',
    'суббота',
  ];
  return days[date.getDay()];
}

export function getFutureDay(day: number) {
  const future = ['сегодня', 'завтра', 'послезавтра'];
  return day < 3
    ? future[day]
    : `${numWord(day, ['дней', 'день', 'дня', 'дней'], false)}`;
}

export function fd(date: Date): string {
  return ['year', 'month', 'day']
    .map((e) =>
      new Intl.DateTimeFormat('en', {
        [e]: 'numeric',
      })
        .format(date)
        .padStart(2, '0')
    )
    .join('-');
}
